/*-----------------------------------------------------------------
- Studio fields
-----------------------------------------------------------------*/
export default {
    action: 'Action',
};
